import * as React from "react";
import { IDefaultViewProps } from "./IDefaultViewProps";
import { Caption } from "../../atoms/views/Caption";
import { ActiviteitIcon } from "../../atoms/icons/ActiviteitIcon";

// All the incoming values
interface IProps {
}

// Outgoing functions
interface IDispatch {
}

// Actual Component
export type AllProps = IProps & IDispatch & IDefaultViewProps<string | null>;
export const Activiteit = (props: AllProps) => {
    return (<Caption {...props} caption={props.label || "Activiteit"} icon={<ActiviteitIcon />}>
        {props.value}
    </Caption>)
}

